import script from "./TagSelectDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TagSelectDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__